import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslationService } from '../../../services/translation-service.service';
import { UITextKeys } from '../../../../constants/UITextKeys';
import { DataAccessService } from '../../../services/data-access.service';
import { AppComponent } from '../../../app.component';

export interface CustomSelectComponentProps {
    modalController: ModalController;
    ts: TranslationService;
    title: string;
    dataArray: any[];
    valueKey: string;
    nameKey?: string;
    allowCreatingNewItems?: boolean;
    hideClearButton?: boolean;
    cols?: any[];
    selected: any,
    multiSelect?: boolean,
    activatedRoute?: ActivatedRoute;
    router?: Router
    exportFunction? : any
}

@Component({
    selector: 'app-custom-select',
    templateUrl: './custom-select.component.html',
    styleUrls: ['./custom-select.component.scss'],
})
export class CustomSelectComponent implements OnInit {

    @Input() title: string;
    @Input() dataArray: any[];
    filteredData: any[] = [];
    @Input() cols: any[] = null;
    searchTerm: string = '';
    @Input() valueKey: string;
    @Input() nameKey: string;
    @Input() allowCreatingNewItems: boolean = false;
    @Input() hideClearButton: boolean = false;
    @Input() ts: TranslationService = null;
    @Input() selected: any = null;
    @Input() multiSelect: boolean = false;
    @Input() exportFunction: any = null;

    constructor(private modalController: ModalController, private dataAccess: DataAccessService) { }

    ngOnInit() {

        if (this.ts === null) {
            this.ts = new TranslationService();
            this.ts.init([...UITextKeys.MainScreens], this.dataAccess);
        }

        if (this.cols === null) {
            this.cols = [
                {
                    'name': 'Name',
                    'key': this.nameKey,
                }
            ];
        }

        this.filteredData = this.dataArray;
    }

    async ngAfterContentInit() {
      
    }

    async itemSelect(item) {
        if (item.CustomSelect_ItemDisabled === true) {
            return;
        }

        if (this.multiSelect) {
            var selectedKeys = (this.selected as any[]);
            if (selectedKeys.indexOf(item[this.valueKey]) > -1) {
                selectedKeys.splice(selectedKeys.indexOf(item[this.valueKey]), 1);
            }
            else {
                selectedKeys.push(item[this.valueKey]);
            }
        }

        else {
            if (item === -1)
                this.modalController.dismiss({ Value: null, Text: null });
            else if (item === null)
                this.modalController.dismiss({ Value: -1, Text: this.searchTerm });
            else
                this.modalController.dismiss({ Value: item[this.valueKey], Text: item[this.nameKey] });
        }
    }

    filter() {
        if (this.searchTerm.length === 0)
            this.filteredData = this.dataArray;

        this.filteredData = this.dataArray.filter((x) => {

            var colSearch = this.cols.map((y) => {
                return x[y.key] && (x[y.key] + '').toLowerCase().indexOf(this.searchTerm.toLowerCase());
            });

            //alert(colSearch);

            var found = colSearch.reduce((y, z) => {
                return y || z > -1;
            }, false);

            //alert(found)

            return found;

            //return x[this.nameKey].toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
        });
    }

    //filter(data) {
    //    if (this.searchTerm.length === 0)
    //        return data;

    //    return data.filter((x) => { return x[this.nameKey].toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1; });
    //}

    dismissModal() {
        this.modalController.dismiss();
    }

    /** Depricated */
    //public static async showCustomSelect(
    //    modalController: ModalController,
    //    title: string,
    //    dataArray: any[],
    //    valueKey: string,
    //    nameKey: string,
    //    allowCreatingNewItems: boolean = false,
    //    hideClearButton: boolean = false,
    //    cols: any[] = null,
    //) {
    //    const modal = await modalController.create({
    //        component: CustomSelectComponent,
    //        componentProps: {
    //            title: title,
    //            dataArray: dataArray,
    //            valueKey: valueKey,
    //            nameKey: nameKey,
    //            allowCreatingNewItems: allowCreatingNewItems,
    //            hideClearButton: hideClearButton,
    //            cols: cols,
    //        },
    //        cssClass: 'full-screen-modal'
    //    });

    //    await modal.present();

    //    const { data } = await modal.onDidDismiss();

    //    return data;
    //}

    public static async show(props: CustomSelectComponentProps) {
        const modal = await props.modalController.create({
            component: CustomSelectComponent,
            componentProps: {
                title: props.title,
                dataArray: props.dataArray,
                valueKey: props.valueKey,
                nameKey: props.nameKey,
                allowCreatingNewItems: props.allowCreatingNewItems,
                hideClearButton: props.hideClearButton,
                cols: props.cols ? props.cols : null,
                ts: props.ts,
                multiSelect: props.multiSelect,
                selected: props.selected,
                exportFunction: props.exportFunction
            },  
            cssClass: 'full-screen-modal'
        });

        if (props.activatedRoute != null)
            AppComponent.setumModalBackButtonHandler(modal, props.activatedRoute, props.router);

        await modal.present();

        const { data } = await modal.onDidDismiss();

        return data;
    }

    itemIsSelected(item) {
        if (!this.multiSelect)
            return this.selected !== undefined && item[this.valueKey] == this.selected;

        return (this.selected as any[]).indexOf(item[this.valueKey]) > -1;
    }

    confirmSelection() {
        this.modalController.dismiss({ Values: this.selected });
    }

    eval(expression) {
        return eval(expression);
    }

    async export() {
        this.exportFunction();
    }
}
